module.exports = __webpack_public_path__ + "static/media/i_male_doctor.9112855f.svg";